import {
  SHOW_PURCHASE_CONFIRMATION_SUCCESS,
  GET_FUNDS_LIST_SUCCESS,
  GET_CATEGORY_LIST_SUCCESS,
  GET_SCHEME_LIST_SUCCESS,
  VALIDATE_SUB_BROKER_SUCCESS,
  CONFIRM_PURCHASE_SUCCESS,
  SET_SIP_DETAILS,
  SIP_SAVE_DATA_SUCCESS,
  SET_SWITCH_DETAILS,
  SWITCH_SAVE_DATA_SUCCESS,
  SET_NEW_PAN,
  SET_STP_DETAILS,
  STP_SAVE_DATA_SUCCESS,
  GET_EARNINGS_SUCCESS,
  GET_EARNINGS,
  SAVE_TRANSACTION_DETAILS,
} from "../types";

export function transactions(
  state = {
    confirmationData: {},
    fundsList: [],
    newPan:"",
    categoryList: [],
    schemeList: [],
    euinList: [],
    sipDetails: {},
    switchDetails: {},
    stpDetails: {},
    transactionDetails: {},
    earnings: []
  },
  action
) {
  switch (action.type) {
    case SHOW_PURCHASE_CONFIRMATION_SUCCESS: {
      const { DtData, Dtdata } = action.body;
      const [data] = DtData || Dtdata;

      return {
        ...state,
        confirmationData: { ...data }
      };
    }
    case GET_FUNDS_LIST_SUCCESS: {
      const { Dtinformation: fundsList = [] } = action.body;
      return { ...state, fundsList, categoryList: [], schemeList: [] };
    }
    case GET_CATEGORY_LIST_SUCCESS: {
      const { Dtinformation: categoryList = [] } = action.body;
      return { ...state, categoryList, schemeList: [] };
    }
    case GET_SCHEME_LIST_SUCCESS: {
      const { Dtinformation: schemeList = [] } = action.body;
      return { ...state, schemeList };
    }
    case VALIDATE_SUB_BROKER_SUCCESS: {
      const { DtData: euinList = [] } = action.body;
      return { ...state, euinList };
    }
    case CONFIRM_PURCHASE_SUCCESS: {
      return { ...state, confirmationData: {} };
    }
    case SET_SIP_DETAILS: {
      return { ...state, sipDetails: action.body };
    }
    case SET_NEW_PAN:{
      return { ...state, newPan: action.body };
    }
    case SIP_SAVE_DATA_SUCCESS: {
      return { ...state, sipDetails: {} };
    }
    case SET_SWITCH_DETAILS: {
      return { ...state, switchDetails: action.body };
    }
    case SWITCH_SAVE_DATA_SUCCESS: {
      return { ...state, switchDetails: {} };
    }
    case SET_STP_DETAILS: {
      return { ...state, stpDetails: action.body };
    }
    case STP_SAVE_DATA_SUCCESS: {
      return { ...state, stpDetails: {} };
    }
    case GET_EARNINGS: {
      return { ...state, earnings: [] };
    }
    case GET_EARNINGS_SUCCESS: {
      const { DtData: earnings = [] } = action.body;
      return { ...state, earnings };
    }
    case SAVE_TRANSACTION_DETAILS: {
      return { ...state, transactionDetails: action.body };
    }
    default:
      return state;
  }
}
